import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    const target = document.getElementById('oferta');
    if (!target) return;
    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 2000; // 2 seconds for a slow feel
    let start: number | null = null;
    function step(timestamp: number) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      const percentage = Math.min(progress / duration, 1);
      // Easing function (easeInOutCubic)
      const ease = percentage < 0.5 ? 4 * percentage * percentage * percentage : 1 - Math.pow(-2 * percentage + 2, 3) / 2;
      window.scrollTo(0, startPosition + distance * ease);
      if (progress < duration) {
        window.requestAnimationFrame(step);
      }
    }
    window.requestAnimationFrame(step);
  };
  return <section className="relative min-h-[90vh] flex overflow-hidden pb-[0px] bg-[#2C2541] pt-[0px] items-center justify-center" data-id="element-117">
      {/* Animated Stars Background */}
      <div className="stars-container" data-id="element-118">
        {[...Array(40)].map((_, i) => <div key={i} className="star" style={{
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        width: `${Math.random() * 2}px`,
        height: `${Math.random() * 2}px`,
        '--duration': `${3 + Math.random() * 5}s`
      } as any} data-id="element-119" />)}
      </div>

      {/* Background Gradients */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none" data-id="element-120">
        <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-[#4B3F6B]/30 blur-[120px] rounded-full" data-id="element-121" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-[#3A3158]/30 blur-[120px] rounded-full" data-id="element-122" />
      </div>

      <div className="relative z-10 w-full text-center" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative mb-6 overflow-hidden shadow-[0_0_50px_rgba(217,177,95,0.15)] border-b border-[#D9B15F]/10" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/7wsV1wwFvUQWkx9ftuVvtN/web.webp" alt="Kit de Liberación Emocional" className="w-full h-auto block" data-id="element-125" />
        </motion.div>

        <div className="max-w-4xl mx-auto px-4 -mt-12 relative z-20" data-id="element-126">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="flex flex-col items-center gap-6" data-id="element-127">
            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={scrollToPricing} className="group relative bg-[#D9B15F] text-[#2C2541] font-black text-base md:text-lg px-8 py-4 rounded-full shadow-[0_0_30px_rgba(217,177,95,0.25)] transition-all uppercase tracking-wider leading-tight max-w-[280px] md:max-w-none" data-id="element-128">
              ✨ QUIERO EMPEZAR A SANAR HOY
              <div className="absolute inset-0.5 rounded-full bg-white/5 blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-129" />
            </motion.button>

            <div className="flex flex-wrap justify-center gap-4 text-[#B99BE8] text-sm font-medium" data-id="element-130">
              <span className="flex items-center gap-1.5" data-id="element-131">
                <span className="text-[#D9B15F]" data-id="element-132">✦</span> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-133">
                <span className="text-[#D9B15F]" data-id="element-134">✦</span> Formato digital
              </span>
              <span className="flex items-center gap-1.5" data-id="element-135">
                <span className="text-[#D9B15F]" data-id="element-136">✦</span> Leé a tu ritmo
              </span>
              <span className="flex items-center gap-1.5" data-id="element-137">
                <span className="text-[#D9B15F]" data-id="element-138">✦</span> Desde cualquier
                dispositivo
              </span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}